document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname !== "/pages/b2b-sign-up") return;

  // const allSections = document.querySelectorAll(
  //   ".page-container .shopify-section"
  // );
  // const targetSection = allSections[1];
  // if (!targetSection) return;

    const targetSection = document.querySelector(
    "#b2b-form"
  );
  
  targetSection.style.position = "relative";

  // ✅ Create button element
  const toggleBtn = document.createElement("button");
  toggleBtn.className = "scrl-btn";

  // ✅ Create SVG icon element
  const arrowSVG = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "svg"
  );
  arrowSVG.setAttribute("class", "arrow-icon");
  arrowSVG.setAttribute("width", "16");
  arrowSVG.setAttribute("height", "16");
  arrowSVG.setAttribute("viewBox", "0 0 24 24");
  arrowSVG.innerHTML = `<path d="M6 9L12 15L18 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`;

  // ✅ Create span for button text
  const btnText = document.createElement("span");
  btnText.textContent = "Scroll Down";

  // ✅ Append icon and text to button
  toggleBtn.appendChild(arrowSVG);
  toggleBtn.appendChild(btnText);

  // ✅ Place button after section
  targetSection.parentNode.insertBefore(toggleBtn, targetSection.nextSibling);

  // ✅ Set initial height
  const collapsedHeight = 520;
  targetSection.style.overflow = "hidden";
  targetSection.style.transition = "height 0.4s ease";
  targetSection.style.height = collapsedHeight + "px";

  let isExpanded = false;

  toggleBtn.addEventListener("click", () => {
    if (isExpanded) {
      targetSection.style.height = collapsedHeight + "px";
      btnText.textContent = "Scroll Down";
      arrowSVG.classList.remove("rotate");
    } else {
      targetSection.style.height = targetSection.scrollHeight + "px";
      btnText.textContent = "Collapse";
      arrowSVG.classList.add("rotate"); // optional rotate on expand
    }
    isExpanded = !isExpanded;
  });
});

// Partner Testimonial
const visibleCount = 4;
let startIndex = 0;

const allTabs = document.querySelectorAll(
  ".testimonial-right .tab:not(.empty)"
);
const arrowUp = document.querySelector(".top-arrow");
const arrowDown = document.querySelector(".bottom-arrow");

function updateVisibleTabs() {
  allTabs.forEach((tab, index) => {
    if (index >= startIndex && index < startIndex + visibleCount) {
      tab.style.display = "flex";
    } else {
      tab.style.display = "none";
    }
  });
}

function showTestimonial(index) {
  const items = document.querySelectorAll(".testimonial-item");
  const tabs = document.querySelectorAll(".testimonial-right .tab:not(.empty)");

  items.forEach((item) => item.classList.remove("active"));
  tabs.forEach((tab) => tab.classList.remove("active"));

  items[index].classList.add("active");
  tabs[index].classList.add("active");
}

arrowUp.addEventListener("click", () => {
  if (startIndex > 0) {
    startIndex--;
    updateVisibleTabs();
  }
});

arrowDown.addEventListener("click", () => {
  if (startIndex + visibleCount < allTabs.length) {
    startIndex++;
    updateVisibleTabs();
  }
});

// Initialize on page load
document.addEventListener("DOMContentLoaded", () => {
  updateVisibleTabs();
});




// Partner FAQ
const newFaqItems = document.querySelectorAll('.newFaq-item');

newFaqItems.forEach(item => {
  const question = item.querySelector('.newFaq-question');
  const icon = item.querySelector('img');

  question.addEventListener('click', () => {
    const isActive = item.classList.contains('active');

    newFaqItems.forEach(i => {
      i.classList.remove('active');
      i.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0707/5079/8078/files/Vector.png?v=1751524800';
    });

    if (!isActive) {
      item.classList.add('active');
      icon.src = 'https://cdn.shopify.com/s/files/1/0707/5079/8078/files/Vector_1.png?v=1751524798';
    }
  });
});